export const getFormGroupFieldValues = (value, checkAll) => {
  if (!value) return [];
  return value.filter((val) =>
    !checkAll ? val?.cusip !== "" : Object.values(val).every(Boolean)
  );
};

export const getFormValue = (value, fallback) => {
  return value || (typeof fallback !== "undefined" ? fallback : null);
};